import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AccessDeniedComponent } from "./component/access-denied/access-denied.component";
import { LgLocalizationModule } from "@logex/framework/lg-localization";
import { UiCoreModule } from "@logex/framework/ui-core";
import { UiSidebarAccountComponent } from "./component/ui-sidebar-account/ui-sidebar-account.component";
import { AssignApplicationRolesComponent } from "./component/assign-application-roles/assign-application-roles.component";
import { LgPivotTableModule } from "@logex/framework/lg-pivot-table";
import { FormsModule } from "@angular/forms";
import { UiToolboxModule } from "@logex/framework/ui-toolbox";
import { AssignApplicationRolesPivot } from "./component/assign-application-roles/pivot/assign-application-roles-pivot";
import {
    BusinessRoleDetailDialog,
    BusinessRoleDetailDialogComponent
} from "./component/business-role-detail-dialog/business-role-detail-dialog.component";
import { BusinessRoleDetailPivot } from "./component/business-role-detail-dialog/pivot/business-role-detail-pivot";
import {
    ImportDialog,
    ImportDialogComponent
} from "./component/import-dialog/import-dialog.component";
import { TagSummaryComponent } from "./component/tag-summary/tag-summary.component";

@NgModule({
    declarations: [
        AccessDeniedComponent,
        UiSidebarAccountComponent,
        AssignApplicationRolesComponent,
        BusinessRoleDetailDialogComponent,
        ImportDialogComponent,
        TagSummaryComponent
    ],
    exports: [
        AccessDeniedComponent,
        UiSidebarAccountComponent,
        AssignApplicationRolesComponent,
        TagSummaryComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        LgLocalizationModule,
        UiCoreModule,
        UiToolboxModule,
        LgPivotTableModule
    ],
    providers: [
        AssignApplicationRolesPivot,
        BusinessRoleDetailDialog,
        BusinessRoleDetailPivot,
        ImportDialog
    ]
})
export class SharedModule {}
